// Global Elements
import { initHeader } from './global-elements/header';
import { initHideRecipeModules } from './global-elements/hide-recipe-modules';
import { initHideRecipesTitle } from './global-elements/hide-recipes-title';
import { initActiveLink } from './global-elements/active-link';
import { initHideReset } from './global-elements/hide-reset';

// Modules

// -----------------------------------------------------------------------------

const init = () => {
  // Shortcodes
  // Global Elements
  initHeader();
  initHideRecipeModules();
  initHideRecipesTitle();
  initActiveLink();
  initHideReset();

  // Modules
};
init();
